export default function Menu() {
  const cellStyle = {
    flex: 1,
    textAlign: "center",
    fontWeight: 600,
    color: "var(--white)",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    fontSize: 12,
  };

  return (
    <div
      style={{
        display: "flex",
        backgroundColor: "var(--primary)",
        height: 40,
        alignItems: "center",
        paddingLeft: 10,
        paddingRight: 10,
      }}
    >
      <div style={{ ...cellStyle, flex: 1 }}>SYMBOL</div>
      <div style={{ ...cellStyle, flex: 1 }}>EXPIRY</div>
      <div style={{ ...cellStyle, flex: 1 }}>MIN</div>
      <div style={{ ...cellStyle, flex: 1 }}>ORDER</div>
      <div style={{ ...cellStyle, flex: 1 }}>MAX</div>
      <div style={{ ...cellStyle, flex: 1 }}>LOT</div>
      <div style={{ ...cellStyle, flex: 1 }}>MARGIN</div>
      <div style={{ ...cellStyle, flex: 1 }}>ACTION</div>
    </div>
  );
}
